import CartDetailsWithData from "./CartDetailsWithData";

export default CartDetailsWithData;
